class NewNavigation extends HTMLElement {
    constructor() {
        super();
        this.hideMenuTimeout = null; // 定义隐藏菜单的延迟
    }

    connectedCallback() {
        this.items = this.querySelectorAll('.new_navigation__item');

        this.items.forEach(item => {
            // 鼠标进入时触发
            item.addEventListener('mouseenter', () => {
                clearTimeout(this.hideMenuTimeout); // 取消隐藏菜单的延迟
                this.handleMouseEnter(item);
            });

            // 鼠标离开时触发
            item.addEventListener('mouseleave', (event) => {
                const relatedTarget = event.relatedTarget;
                if (relatedTarget && relatedTarget.closest('.new_navigation__item')) {
                    return;
                }

                // 设置延迟，200ms后隐藏菜单
                this.hideMenuTimeout = setTimeout(() => {
                    this.handleMouseLeave(item);
                }, 200);
            });
        });
    }

    disconnectedCallback() {
        // 移除所有事件监听器
        this.items.forEach(item => {
            item.removeEventListener('mouseenter', this.handleMouseEnter);
            item.removeEventListener('mouseleave', this.handleMouseLeave);
        });
    }

    handleMouseEnter(item) {
        // 关闭其他打开的菜单
        this.items.forEach(otherItem => {
            if (otherItem !== item && otherItem.hasAttribute('open')) {
                otherItem.removeAttribute('open');
            }
        });

        // 打开当前菜单
        if (!item.hasAttribute('open')) {
            item.setAttribute('open', '');
        }
    }

    handleMouseLeave(item) {
        // 关闭当前菜单
        if (item.hasAttribute('open')) {
            item.removeAttribute('open');
        }
    }
}

customElements.define('new-navigation', NewNavigation);

class NaviSideList extends HTMLElement {
    constructor() {
        super();
        this.hasMatchedImages = false;
        this.hasParsedMarketsJson = false;
        this.marketsJsonData = [];
        this.handleMouseEnter = this.handleMouseEnter.bind(this);
        this.listSide = this.querySelector('.submenu-down-list__side');
        this.line = this.querySelector('.new_navigation__line');
    }

    connectedCallback() {
        // 缓存常用的 DOM 元素
        this.parentContainer = this.querySelector('.submenu-down-list__side');
        this.childContainer = this.querySelector('.submenu-down-list__main');
        this.childLists = this.childContainer?.querySelectorAll('.childlink__grandchild__list') || [];

        if (this.parentContainer) {
            this.parentLinks = this.parentContainer.querySelectorAll('.childlink__item__link');
            // 使用事件代理
            this.parentContainer.addEventListener('mouseenter', this.handleMouseEnter, true);
        }


    
        this.applyMasonryLayout();
        this.matchCollectionImage();
        this.checkScroll();
    }

    disconnectedCallback() {
        if (this.parentContainer) {
            this.parentContainer.removeEventListener('mouseenter', this.handleMouseEnter, true);
        }
    }

    checkScroll() {
        if (this.listSide && this.listSide.scrollHeight > this.listSide.clientHeight) {
            this.classList.add('can_scroll');
        } else {
            this.classList.remove('can_scroll');
        }
    }

    handleMouseEnter(event) {
        const target = event.target;
        if (!target.classList.contains('childlink__item__link')) return;

        const index = Array.from(this.parentLinks).indexOf(target);
        if (index < 0) return;

        const grandchildParents = Array.from(this.parentLinks).filter(parent =>
            parent.classList.contains('has_grandchild')
        );

        const grandchildIndex = grandchildParents.indexOf(this.parentLinks[index]);
        if (grandchildIndex < 0 || !this.childLists[grandchildIndex]) return;

        this.parentLinks.forEach((parent, i) => {
            if (i === index && parent.classList.contains('has_grandchild')) {
                parent.classList.add('active');
                this.childLists[grandchildIndex].classList.add('active');
            } else {
                parent.classList.remove('active');
                const childListIndex = grandchildParents.indexOf(parent);
                if (childListIndex >= 0 && this.childLists[childListIndex]) {
                    this.childLists[childListIndex].classList.remove('active');
                }
            }
        });
    }

    applyMasonryLayout() {
        if (!this.childContainer) return;

        const containers = this.childContainer.querySelectorAll('.childlink__grandchild__list__inner__list:not(.no_masonry):not(.new_navigation_mobile__item_parent-container)');
        const windowWidth = window.innerWidth; // 提前获取窗口宽度

        containers.forEach((container) => {
            const childSize = container.childElementCount; // 获取直接子元素数量
            let shouldAddMasonryClass = false;

            // 合并条件逻辑
            if ((windowWidth < 1200 && childSize > 2) || (windowWidth >= 1200 && childSize > 3)) {
                shouldAddMasonryClass = true;
                container.classList.add('masonry_item'); // 添加类名
            }

            // 如果符合条件，则初始化Macy
            if (shouldAddMasonryClass) {
                Macy({
                    container: container,
                    trueOrder: false,
                    waitForImages: false,
                    margin: {
                        x: 60,
                        y: 40
                    },
                    columns: 3,
                    breakAt: {
                        1025: {
                            margin: {
                                x: 10,
                                y: 40,
                            },
                            columns: 2
                        },
                        1000: {
                            margin: {
                                x: 20,
                                y: 50,
                            },
                            columns: 2
                        }
                    }
                });
            }
        });
    }

    matchCollectionImage() {
 
        if (this.hasMatchedImages) return;
 
        if (!this.hasParsedMarketsJson) {
            const marketsJson = document.querySelector('.markets_product_json');
            if (marketsJson) {
                const marketsJsonContent = marketsJson.textContent || '[]';
                try {
                    this.marketsJsonData = JSON.parse(marketsJsonContent);
                } catch (e) {
                    console.error('Error parsing markets JSON:', marketsJsonContent, e);
                    return;
                }
            } else {
                return;
            }
            this.hasParsedMarketsJson = true;
        }
 
        const handleItems = (selector) => {
            const items = this.querySelectorAll(selector);
           
            items.forEach(item => {
                const productJson = item.querySelector('.grandchild_product_json');
               
                if (!productJson) return;

                const jsonContent = productJson.textContent || '[]';
                let jsonData = [];
                try {
                    jsonData = JSON.parse(jsonContent);
                } catch (e) {
                    console.error('Error parsing product JSON:', jsonContent, e);
                    return;
                }
 
                jsonData.forEach(product => {
                    const variants = product.variants || [];
           
                    variants.forEach(variant => {
                        const matchedMarket = this.marketsJsonData.find(market => market.shopify_variant_id === variant.id);
                      
                        if (matchedMarket && variant.featured_image?.src) {
                            // console.log(variant.id);
                            const imgElement = item.querySelector('.grandchild-link__item__image img');
                            if (imgElement) {
                                imgElement.src = variant.featured_image.src;
                                imgElement.srcset = '';
                                imgElement.sizes = '';
                            }
                        }
                    });
                });
            });
        };

        if (this.classList.contains('submenu-down-list--style-4') || this.classList.contains('submenu-mobile-down-list--style-4')) {
            handleItems('.grandchild-link__item');
        }

        // 释放内存
        this.querySelectorAll('.grandchild_product_json').forEach(productJson => productJson.remove());

        this.hasMatchedImages = true;
    }
}

customElements.define('navi-side-list', NaviSideList);

class NaviMobile extends HTMLElement {
    constructor() {
        super();
        // 绑定方法以确保正确的 this 指向
        this.setNaviTop = this.setNaviTop.bind(this);
        this.openMobileNavi = this.openMobileNavi.bind(this);
        this.closeMobileNavi = this.closeMobileNavi.bind(this);
        this.setMobileNavHeaderHeight = this.setMobileNavHeaderHeight.bind(this);
        this.openParentList = this.openParentList.bind(this);
        this.openChildList = this.openChildList.bind(this);
        this.closeChildList = this.closeChildList.bind(this);
        this.openBlockParentList = this.openBlockParentList.bind(this);
        this.toggleGrandchildList = this.toggleGrandchildList.bind(this);
    }

    connectedCallback() {
        // 缓存常用的 DOM 元素
        this.expandButton = this.querySelector('.header-navi-expand');
        this.mobileNavi = this.querySelector('.new_navigation_mobile');
        this.parentContainers = this.querySelectorAll('.new_navigation_mobile__item_parent-container:not(.new_navigation_mobile__item-block)');
        this.childItems = this.querySelectorAll('.new_navigation_mobile__children-list__item');
        this.backButtons = this.querySelectorAll('.submenu-mobile-down-list__header__back');
        this.blockParentContainers = this.querySelectorAll('.new_navigation_mobile__item-block.new_navigation_mobile__item_parent-container');
        this.closeButtons = this.querySelectorAll('.new_navigation_mobile_header_close');
        this.mobileAdvs = this.querySelectorAll('.submenu-down-list__advertising_item_content');

        // 设置导航栏和移动导航栏高度
        this.setNaviTop();
        window.addEventListener('scroll', this.setNaviTop);

        this.setMobileNavHeaderHeight();

        // 绑定事件监听器
        if (this.expandButton) {
            this.expandButton.addEventListener('click', this.openMobileNavi);
        }

        this.parentContainers.forEach(parentContainer => {
            parentContainer.addEventListener('click', this.openParentList);
        });

        this.mobileAdvs.forEach(mobileAdv => {
            mobileAdv.addEventListener('click', this.openAdvLink);
        });

        this.childItems.forEach(childItem => {
            childItem.addEventListener('click', this.openChildList);
        });

        this.backButtons.forEach(backButton => {
            backButton.addEventListener('click', this.closeChildList);
        });

        this.blockParentContainers.forEach(blockParentContainer => {
            blockParentContainer.addEventListener('click', this.openBlockParentList);
        });

        this.closeButtons.forEach(closeButton => {
            closeButton.addEventListener('click', this.closeMobileNavi);
        });

        // 获取所有标题盒子元素并添加点击事件
        this.titleBoxes = this.querySelectorAll('.new_navigation_mobile__children-list__item-title-box');
        this.titleBoxes.forEach(titleBox => {
            titleBox.addEventListener('click', this.toggleGrandchildList);
        });
    }

    disconnectedCallback() {
        // 移除事件监听器，防止内存泄漏
        window.removeEventListener('scroll', this.setNaviTop);

        if (this.expandButton) {
            this.expandButton.removeEventListener('click', this.openMobileNavi);
        }

        this.parentContainers.forEach(parentContainer => {
            parentContainer.removeEventListener('click', this.openParentList);
        });

        this.childItems.forEach(childItem => {
            childItem.removeEventListener('click', this.openChildList);
        });

        this.backButtons.forEach(backButton => {
            backButton.removeEventListener('click', this.closeChildList);
        });

        this.blockParentContainers.forEach(blockParentContainer => {
            blockParentContainer.removeEventListener('click', this.openBlockParentList);
        });

        this.closeButtons.forEach(closeButton => {
            closeButton.removeEventListener('click', this.closeMobileNavi);
        });

        // 移除标题盒子的事件监听器
        this.titleBoxes.forEach(titleBox => {
            titleBox.removeEventListener('click', this.toggleGrandchildList);
        });
    }

    setNaviTop() {
        const root = document.documentElement;
        root.style.setProperty('--mobile-header-height', '0px');
    }

    setMobileNavHeaderHeight() {
        const mobileHeader = this.querySelector('.new_navigation_mobile_header');
        const root = document.documentElement;

        if (mobileHeader) {
            const mobileHeaderHeight = mobileHeader.offsetHeight;
            root.style.setProperty('--mobile-nav-header-height', `${mobileHeaderHeight}px`);
        }
    }

    openMobileNavi(event) {
        event.stopPropagation();

        if (this.expandButton) {
            this.expandButton.setAttribute('aria-expanded', 'true');
        }

        if (this.mobileNavi) {
            this.mobileNavi.setAttribute('open', '');
        }

        document.body.style.overflow = 'hidden';
    }

    closeMobileNavi(event) {
        event.stopPropagation();

        if (this.expandButton) {
            this.expandButton.setAttribute('aria-expanded', 'false');
        }

        if (this.mobileNavi) {
            this.mobileNavi.removeAttribute('open');
        }

        // 关闭所有子菜单
        this.querySelectorAll('.submenu-mobile-down-list-container[open]').forEach(container => {
            container.removeAttribute('open');
        });

        document.body.style.overflow = '';
    }
    
    openAdvLink(event) {
        event.stopPropagation();
        const mobileAdv = event.currentTarget;
        const link = mobileAdv.querySelector('.submenu-down-list__advertising_item_content_box_link');
        
        if (link) {
            window.location.href = link.href;
        }
    }

    openParentList(event) {
        event.stopPropagation();
        const parentContainer = event.currentTarget;
        const childrenList = parentContainer.nextElementSibling;

        const siblingItems = parentContainer.closest('.new_navigation_mobile__item').parentNode.children;

        Array.from(siblingItems).forEach(item => {
            if (item !== parentContainer.closest('.new_navigation_mobile__item')) {
                const siblingChildrenList = item.querySelector('.new_navigation_mobile__children-list-outer');
                if (siblingChildrenList && !$(siblingChildrenList).is(':animated')) {
                    $(siblingChildrenList).slideUp(300);
                }
                item.classList.remove('active');
            }
        });

        if (childrenList && childrenList.classList.contains('new_navigation_mobile__children-list-outer')) {
            if (!$(childrenList).is(':animated')) {
                $(childrenList).slideToggle(300);
            }

            const parentItem = parentContainer.closest('.new_navigation_mobile__item');
            if (parentItem) {
                parentItem.classList.toggle('active');
            }
        }
    }


    openChildList(event) {
        event.stopPropagation();
        const childItem = event.currentTarget;
        const submenuContainer = childItem.querySelector('.submenu-mobile-down-list-container');

        if (submenuContainer) {
            submenuContainer.setAttribute('open', '');
        }
    }

    closeChildList(event) {
        event.stopPropagation();
        const backButton = event.currentTarget;
        const submenuContainer = backButton.closest('.submenu-mobile-down-list-container');

        if (submenuContainer) {
            submenuContainer.removeAttribute('open');
        }
    }

    openBlockParentList(event) {
        event.stopPropagation();
        const blockParentContainer = event.currentTarget;
        const submenuContainer = blockParentContainer.nextElementSibling;

        if (submenuContainer && submenuContainer.classList.contains('submenu-mobile-down-list-container')) {
            submenuContainer.setAttribute('open', '');
        }
    }

    toggleGrandchildList(event) {
        event.stopPropagation();
        const titleBox = event.currentTarget;
        const grandchildList = titleBox.nextElementSibling;
        console.log(titleBox,"titleBox");
        // 检查是否存在孙子列表且类名正确
        if (grandchildList && grandchildList.classList.contains('new_navigation_mobile__grandchild-list-outer')) {
            // 使用jQuery的slideToggle实现平滑动画
            if (!$(grandchildList).is(':animated')) {
                
                $(grandchildList).slideToggle(300);
                // 切换active类
                titleBox.classList.toggle('active');

                // 获取所有兄弟元素下的titleBox并移除active类
                const parentItem = titleBox.closest('.new_navigation_mobile__children-list__item');
                const siblingItems = parentItem.parentElement.children;
                Array.from(siblingItems).forEach(item => {
                    if(item !== parentItem) {
                        const siblingTitleBox = item.querySelector('.new_navigation_mobile__children-list__item-title-box');
                        if(siblingTitleBox) {
                            siblingTitleBox.classList.remove('active');
                        }
                        const siblingGrandchildList = item.querySelector('.new_navigation_mobile__grandchild-list-outer');
                        if(siblingGrandchildList && !$(siblingGrandchildList).is(':animated')) {
                            $(siblingGrandchildList).slideUp(300);
                        }
                    }
                });
            }
        }
    }
}

customElements.define('navigation-mobile', NaviMobile);


$(".new_navigation_mobile__item[data-menu-type='style_4'] .grandchild-link__item").click(function() {
    // 获取当前点击元素的下一个 .level_4-box 元素
    const $currentLevel4Box = $(this).next(".level_4-box");
    
    // 获取所有其他的 .level_4-box 元素并收起它们
    $(this).closest('.new_navigation_mobile__item')
        .find('.level_4-box')
        .not($currentLevel4Box)
        .slideUp();
    
    // 移除其他 grandchild-link__item 的 active 类
    $(this).closest('.new_navigation_mobile__item')
        .find('.grandchild-link__item')
        .not(this)
        .removeClass('active');
    
    // 切换当前元素
    $currentLevel4Box.slideToggle();
    $(this).toggleClass("active");
});


$('.new_navigation_mobile_footer .default-title').click(function() {
    const $countryList = $(this).next('.country-list');
 
  $(this).toggleClass('active');
    $countryList.slideToggle(300);
   
});
 